import { AuxiliumComponent } from "../auxilium-component";

export default class FrameContent extends AuxiliumComponent {
	static observable = ["spacing"];
	static observableBooleans = ["centred"];

	parsedCallback() {
		this.appendChild(document.createElementWithContents("main", this.childNodes, { className: this.centred ? "container" : "frame__main", id: "mainContent" }));
	}

	attributeChanged(name, _, newValue) {
		if (name === "centred") {
			const main = this.querySelector(":scope > main");

			if (main) {
				main.className = this.IsAttributeValueTrue(newValue) ? "container" : "frame__main";
			}
		}
	}
}
